// src/components/admin/EstadoReciboSelect.jsx
import Select from "./Select";
import { RECIBO_ESTADOS } from "../Utiles/helpers";

const EstadoReciboSelect = ({ value, onChange, className }) => {
  const val =
    RECIBO_ESTADOS.includes(String(value || "").toUpperCase())
      ? String(value).toUpperCase()
      : "COBRADO";
  return (
    <Select value={val} onChange={(e) => onChange(e.target.value)} className={className || "w-[180px]"}>
      {RECIBO_ESTADOS.map((s) => (
        <option key={s} value={s}>
          {s}
        </option>
      ))}
    </Select>
  );
};
export default EstadoReciboSelect;
